"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = require("./namespace");
var makeGetPath_1 = __importDefault(require("./makeGetPath"));
var makeGetRoutePath_1 = __importDefault(require("./makeGetRoutePath"));
var getParam_1 = require("./getParam");
exports.getParam = getParam_1.default;
// TODO watch for https://github.com/Microsoft/TypeScript/issues/10727 to fix any types
function buildRouteTree(rawTree) {
    return (function loop(tree, path) {
        if (path === void 0) { path = []; }
        return Object
            .entries(tree)
            .reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            var _b, _c;
            var xPath = path.concat([{ value: key, isParam: namespace_1.isParamGuard(value) }]);
            var routeData = {
                getRoutePath: makeGetRoutePath_1.default(xPath),
                getRedirectPath: makeGetPath_1.default(xPath),
                getElementKey: function () { return key; },
            };
            if (!namespace_1.isRawRouteTree(value)) {
                return __assign({}, acc, (_b = {}, _b[key] = routeData, _b));
            }
            return __assign({}, acc, (_c = {}, _c[key] = __assign({}, loop(value, xPath), routeData), _c));
        }, {});
    })(rawTree);
}
exports.default = buildRouteTree;
